// extracted by mini-css-extract-plugin
export default {"form":"ProcessEdit_form__iWi0X","item":"ProcessEdit_item__60GzL","buttons":"ProcessEdit_buttons__H3u-l"};